export const VEHICLE_FITMENT = {
  UNIVERSAL: "UNIVERSAL",
  VEHICLE_SPECIFIC: "VEHICLE_SPECIFIC",
  UNKNOWN: "UNKNOWN",
  UNKNOWN_FITMENT: "UNKNOWN_FITMENT",
};

export const SALE_TYPE = {
  UPTOOFF: "UPTOOFF",
  FROM: "FROM",
  LIMITEDOFFER: "LIMITEDOFFER",
  LIMITEDOFFERUPTO: "LIMITEDOFFERUPTO",
  DEALUPTO: "DEALUPTO",
  SAVE: "SAVE",
  ENDINGSOON: "ENDINGSOON",
};

export const FREE_DELIVERY_PRICE = 9999;

export const tier0s = [
  {
    name: "Replacement Parts",
    icon: "replacement-parts",
    id: "replacement parts",
    url: "/replacement-parts",
  },
  {
    name: "Body Parts",
    icon: "body-parts",
    id: "body parts",
    url: "/automotive-body-parts",
  },
  {
    name: "Automotive Lightings",
    icon: "automotive-lightings",
    id: "automotive lightings",
    url: "/automotive-lightings",
  },
  {
    name: "Tools & Equipment",
    icon: "tools-equipment",
    id: "tools & equipment",
    url: "/tools-and-equipment",
  },
  {
    name: "Performance Parts",
    icon: "performance-parts",
    id: "performance parts",
    url: "/performance-parts",
  },
  {
    name: "Wheels & Tires",
    icon: "wheels-tires",
    id: "wheels & tires",
    url: "/wheels",
  },
  {
    name: "Interior",
    icon: "interior-parts",
    id: "interior",
    url: "/interior",
  },
  {
    name: "Exterior",
    icon: "exterior-parts",
    id: "exterior",
    url: "/exterior",
  },
  {
    name: "Specialty Parts",
    icon: "specialty-parts",
    id: "specialty parts",
    url: "/specialty-parts",
  },
  {
    name: "Merchandise",
    icon: "",
    id: "merchandise",
    url: "/merchandise",
  },
];

export const READ_ALL_REVIEWS_URL = "https://search.google.com/local/reviews?placeid=ChIJV_3gXV7S1IkRnZujM9GnVDo";
